@import '../../style/focus-outline.scss';

:host {

    /* All css variables are in grid.scss.
       Any variable can be overridden here for a single grid-column by using the correct selector in CSS */

    display: contents;

    th {
        color: var(--wcs-grid-header-text-color);
        background-color: var(--wcs-grid-header-background-color-default);
        border-bottom: var(--wcs-grid-header-border-bottom);
        border-left: var(--wcs-grid-header-border-left);
        border-radius: var(--wcs-grid-header-border-radius);
        padding: var(--wcs-grid-header-padding-vertical) var(--wcs-grid-header-padding-horizontal);
        text-align: left;
        align-content: center;
        transition: background-color var(--wcs-grid-header-transition-duration) ease-in-out;

        .grid-column-th-content {
            // The following lines aim to avoid displaying the native button style of the agent
            -webkit-appearance: none;
            appearance: none;
            background: none;
            border: none;
            outline: none;
            margin: 0;
            padding: 0;
            font-size: var(--wcs-grid-header-font-size);
            line-height: var(--wcs-grid-header-line-height);
            color: var(--wcs-grid-header-text-color);
            cursor: inherit;
            display: inline-flex;
            border-collapse: separate;
            font-family: inherit;
            text-align: left;
            align-items: center;
            gap: var(--wcs-semantic-spacing-base);

            span {
                font-weight: var(--wcs-grid-header-font-weight);
            }
        }

        /* Hovered grid header */
        &[aria-sort]:hover {
            background-color: var(--wcs-grid-header-background-color-hover);
        }

        /* Pressed grid header */
        &[aria-sort]:active {
            background-color: var(--wcs-grid-header-background-color-press);
        }

        /* Grid header with asc or desc sort-config */
        &[aria-sort=ascending],
        &[aria-sort=descending] {
            --wcs-grid-header-sort-arrow-color: var(--wcs-grid-header-sort-arrow-color-default);
        }

        /* Hovered grid header, not sorted yet */
        &[aria-sort=none]:hover {
            --wcs-grid-header-sort-arrow-color: var(--wcs-grid-header-sort-arrow-color-hover);
        }

        // XXX: This code works in Firefox as well, but there is a browser-side rendering bug that prevents it from displaying correctly.
        // We decided to wait for Firefox to fix the bug instead adding a dirty fix here
        &:focus-visible, &:has(:focus-visible) {
            @include focus-outline($outline-color: var(--wcs-grid-outline-color), $outline-offset: 0);
        }

        @supports not selector(&:has(:focus-visible)) {
            &:focus-within {
                @include focus-outline($outline-color: var(--wcs-grid-outline-color), $outline-offset: 0);
            }
        }
    }
    .pointer {
        cursor: pointer;
    }
}

:host([hidden]) {
    display: none !important;
}
